// NOTE: in order to avoid fake build errors about missing dependencies in libComm itself,
//       it is important to declare in main-application's "app.module.ts" the following :
// ...
// import {LibCommModule} from "libComm";
// ...
// imports: [
//           ...
//           libCommModule,
//           ...
// ]
//
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {ActionBarComponent} from '../components/action-bar/action-bar.component';
import {CustomBtnComponent} from '../components/custom-btn/custom-btn.component';
import {CustomSelectComponent} from '../components/custom-select/custom-select.component';
import {AppInfoComponent} from '../components/dialog/app-info/app-info.component';
import {DialogComponent} from '../components/dialog/dialog.component';
import {SaveConfirmComponent} from '../components/dialog/save-confirm/save-confirm.component';
import {LcCustomMultiselectV1Component} from '../components/lc-custom-multiselect-v1/lc-custom-multiselect-v1.component';
import {LcCustomSelectV1Component} from '../components/lc-custom-select-v1/lc-custom-select-v1.component';
import {LcCustomSelectPaginatedComponent} from '../components/lc-custom-select-paginated/lc-custom-select-paginated.component';
import {LcCustomTablePaginatorComponent} from '../components/lc-custom-table-paginator/lc-custom-table-paginator.component';
import {MenuListItemComponent} from '../components/menu-list-item/menu-list-item.component';
import {MenuSideBarComponent} from '../components/menu-side-bar/MenuSideBar.component';
import {TopbarComponent} from '../components/topbar/topbar.component';
import {GetValueOnConditionPipe} from '../pipes/get-value-on-condition.pipe';
import {TooltipSelectComponentsPipe} from '../pipes/tooltip-select-components.pipe';
import {TranslateOptionWithPrefixPipe} from '../pipes/translate-option-with-prefix.pipe';

// import {MatSlideToggleModule} from "@angular/material/slide-toggle";
// import {FormsModule} from "@angular/forms";
// import {TranslateModule} from "@ngx-translate/core";
// import {MatButtonModule} from "@angular/material/button";
// import {MatDialogModule} from "@angular/material/dialog";


// dummy component (only debug)
// import {DummyComponent} from '../components/Dummy.component';


// for routing
// import {LibCommRoutingModule} from "./libComm.routing.module";


@NgModule({
	declarations: [
		// NOTE: declare here only "not-standalone" components that take part in library-only "build" process (and exports)
		//
		// DummyComponent, 
		// ActionBarComponent,
		// DialogComponent,
		// SaveConfirmComponent,
		// AppInfoComponent,
		ActionBarComponent,
		CustomBtnComponent,
		CustomSelectComponent,
		AppInfoComponent,
		DialogComponent,
		SaveConfirmComponent,
		LcCustomMultiselectV1Component,
		LcCustomSelectV1Component,
		LcCustomSelectPaginatedComponent,
		LcCustomTablePaginatorComponent,
		MenuListItemComponent,
		MenuSideBarComponent,
		TopbarComponent,
		GetValueOnConditionPipe,
		TooltipSelectComponentsPipe,
		TranslateOptionWithPrefixPipe
	],
	imports: [
		// NOTE: puts here "imports dependencies" required by the library itself for building
		//
		// DummyComponent
		// MatButtonModule,
		// MatDialogModule,
		// MatSlideToggleModule,
		// TranslateModule,
		// FormsModule
		CommonModule,
		FormsModule,
		MatBadgeModule,
		MatButtonModule,
		MatDialogModule,
		MatIconModule,
		MatListModule,
		MatMenuModule,
		MatSelectModule,
		MatSlideToggleModule,
		MatToolbarModule,
		MatTooltipModule,
		RouterModule,
		TranslateModule
	],
	exports: [
		// NOTE: declare here components/pipes/etc. that will be available in "main applications"
		//
		// DummyComponent,
		// MatButtonModule,
		// MatDialogModule,
		// MatSlideToggleModule,
		// TranslateModule,
		// FormsModule
		ActionBarComponent,
		CustomBtnComponent,
		CustomSelectComponent,
		AppInfoComponent,
		DialogComponent,
		SaveConfirmComponent,
		LcCustomMultiselectV1Component,
		LcCustomSelectV1Component,
		LcCustomSelectPaginatedComponent,
		LcCustomTablePaginatorComponent,
		MenuListItemComponent,
		MenuSideBarComponent,
		TopbarComponent,
		GetValueOnConditionPipe,
		TooltipSelectComponentsPipe,
		TranslateOptionWithPrefixPipe
	]
})
export class LibCommModule
{
}
